import { useEffect } from "react";

export default function GorgiasChatLoader() {
  useEffect(() => {
    const loadGorgias = () => {
      if (window.gorgiasDidInit) return;

      const script = document.createElement("script");
      script.src =
        "https://config.gorgias.chat/gorgias-chat-bundle-loader.js?applicationId=01GYCBRFJX7H9VAB3T2WNHCZD3";
      script.defer = true;
      document.body.appendChild(script);

      window.gorgiasDidInit = true;
    };

    const onInteraction = () => {
      loadGorgias();
      window.removeEventListener("scroll", onInteraction);
      window.removeEventListener("click", onInteraction);
    };

    window.addEventListener("scroll", onInteraction, { passive: true });
    window.addEventListener("click", onInteraction, { passive: true });

    return () => {
      window.removeEventListener("scroll", onInteraction);
      window.removeEventListener("click", onInteraction);
    };
  }, []);

  return null;
}
